<template>
  <div :class="notificationContainerClass"
       v-if="isShow">
    <div class="d-flex">
      <div class="pr-1 align-self-center notification-body">
        <strong>
          <i class="fa fa-info-circle mr-1" />
          {{ title }}
        </strong>
        <span class="d-block mt-1">{{ body }}</span>
      </div>
      <div class="ml-auto d-flex flex-md-row flex-column justify-content-center align-items-center">
        <b-button v-if="isAdmin"
                  class="text-nowrap"
                  variant="primary"
                  size="sm"
                  @click="openRingGroups">
          Review Inbox Assignments
        </b-button>
        <compact-btn customClass="fs-14 _500 position-relative not-focusable ml-2"
                     borderless
                     @clicked="close">
          <i class="fa fa-times" />
        </compact-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { hasBridge, sendToMain } from 'src/plugins/helpers/electron'
import { aclMixin, classicMixin, userMixin } from 'src/plugins/mixins'
import CompactBtn from 'components/compact-btn'

const STORAGE_KEY = 'line_management_banner_dismissed'

export default {
  name: 'line-management-banner',

  components: { CompactBtn },

  mixins: [
    aclMixin,
    classicMixin,
    userMixin
  ],

  data () {
    return {
      isDismissed: false
    }
  },

  computed: {
    isShow () {
      return !this.isDismissed &&
        this.isTeamInbox &&
        this.currentCompany?.team_inbox_line_management_banners === true &&
        this.currentCompany?.team_inbox_line_management_enhancements !== true
    },

    title () {
      return this.isAdmin
        ? 'Your team\'s line access is changing'
        : 'Your line access is changing soon'
    },

    body () {
      return this.isAdmin
        ? 'After this account is updated, agents will only see lines connected to their Inboxes. Review each agent\'s Inbox assignments now to prevent unexpected loss of line or Caller ID access.'
        : 'After this update, you\'ll only see lines connected to your Inboxes. If you need access to other lines, reach out to your admin to be added to the right Inbox.'
    },

    notificationContainerClass () {
      return 'px-2 w-100 py-2 px-3 position-relative notification-container-header notification-info'
    },

    isTeamInbox () {
      return this.$route.path.startsWith('/team-inboxes')
    },

    ringGroupsUrl () {
      return `${this.getClassicURL()}/ring-groups/`
    }
  },

  mounted () {
    this.isDismissed = localStorage.getItem(STORAGE_KEY) === 'true'
    this.$root.$on('line-management-banner-dismissed-reset', () => {
      this.isDismissed = false
    })
  },

  beforeDestroy () {
    this.$root.$off('line-management-banner-dismissed-reset')
  },

  methods: {
    close () {
      localStorage.setItem(STORAGE_KEY, 'true')
      this.isDismissed = true
    },

    openRingGroups () {
      if (hasBridge()) {
        sendToMain('open_external_url', this.ringGroupsUrl)
        return
      }

      window.open(this.ringGroupsUrl, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.notification-body {
  font-size: 13px;
}

.notification-info {
  background-color: #cce5ff;
  border-bottom: 1px solid #b8daff;
  color: #004085;
}
</style>
